import { useState, type FormEvent } from 'react';

const FORM_SUBMIT_URL = 'https://readdy.ai/api/form/d9li9a4it35ii3jdl8n0';

export default function ContactSection() {
  const [formStatus, setFormStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('phone_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setFormStatus('success');
      setFormMessage('留言已提交');
      return;
    }
    formData.delete('phone_alt');
    setFormStatus('submitting');
    try {
      const resp = await fetch(FORM_SUBMIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await resp.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(text); } catch { /* ignore */ }
      if (resp.ok && parsed && (parsed as Record<string, unknown>).code === 'OK') {
        setFormStatus('success');
        setFormMessage('感谢投稿！我们会尽快处理您的留言。');
        form.reset();
      } else {
        setFormStatus('error');
        const serverMsg =
          (parsed && typeof (parsed as Record<string, unknown>).meta === 'object' && ((parsed as Record<string, unknown>).meta as Record<string, string>).message) ||
          (parsed && (parsed as Record<string, string>).message) ||
          '提交失败，请稍后重试';
        setFormMessage(String(serverMsg));
      }
    } catch {
      setFormStatus('error');
      setFormMessage('网络错误，请稍后重试');
    }
  };

  return (
    <section id="contact" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-3">
            <i className="ri-mail-send-line"></i>
            联系我们
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">
            投稿爆料
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mb-8">
            你有独家内幕或最新八卦？欢迎向我们投稿，让你的爆料被更多人看到
          </p>

          <div className="bg-background-50 border border-secondary-200/60 rounded-2xl p-6 md:p-8">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
              <div className="flex flex-col items-center gap-2 p-4 rounded-xl bg-background-100">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100">
                  <i className="ri-mail-line text-xl text-primary-500"></i>
                </div>
                <span className="text-sm font-medium text-foreground-700">投稿邮箱</span>
                <span className="text-xs text-foreground-500">tips@heiliao.example.com</span>
              </div>
              <div className="flex flex-col items-center gap-2 p-4 rounded-xl bg-background-100">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100">
                  <i className="ri-wechat-line text-xl text-accent-500"></i>
                </div>
                <span className="text-sm font-medium text-foreground-700">微信客服</span>
                <span className="text-xs text-foreground-500">heiliao_official</span>
              </div>
              <div className="flex flex-col items-center gap-2 p-4 rounded-xl bg-background-100">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100">
                  <i className="ri-phone-line text-xl text-secondary-500"></i>
                </div>
                <span className="text-sm font-medium text-foreground-700">商务合作</span>
                <span className="text-xs text-foreground-500">biz@heiliao.example.com</span>
              </div>
            </div>

            <div className="text-left">
              <h3 className="text-base font-heading font-bold text-foreground-800 mb-3">快速留言</h3>
              <form className="space-y-3" data-readdy-form onSubmit={handleSubmit}>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <input
                    type="text"
                    name="name"
                    placeholder="你的昵称"
                    className="w-full px-4 py-2.5 rounded-lg border border-secondary-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="联系邮箱"
                    className="w-full px-4 py-2.5 rounded-lg border border-secondary-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                  />
                </div>
                <textarea
                  name="message"
                  placeholder="请描述你的爆料内容或合作意向..."
                  rows={3}
                  maxLength={500}
                  className="w-full px-4 py-2.5 rounded-lg border border-secondary-200 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                ></textarea>
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="antispam-field"
                />
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
                  <button
                    type="submit"
                    disabled={formStatus === 'submitting'}
                    className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-2.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed"
                  >
                    {formStatus === 'submitting' ? (
                      <>
                        <i className="ri-loader-4-line animate-spin"></i>
                        提交中...
                      </>
                    ) : (
                      <>
                        <i className="ri-send-plane-line"></i>
                        提交留言
                      </>
                    )}
                  </button>
                  {formStatus === 'success' && (
                    <span className="text-sm text-green-600 flex items-center gap-1">
                      <i className="ri-check-line"></i>
                      {formMessage}
                    </span>
                  )}
                  {formStatus === 'error' && (
                    <span className="text-sm text-primary-500 flex items-center gap-1">
                      <i className="ri-error-warning-line"></i>
                      {formMessage}
                    </span>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}